export const SELECTED_PASSENGER_DETAILS='SELECTED_PASSENGER_DETAILS';
export const ORIGIN_DROPDOWN='ORIGIN_DROPDOWN';
export const DESTINATION_DROPDOWN='DESTINATION_DROPDOWN';
export const FEESERVICE_DROPDOWN='FEESERVICE_DROPDOWN';
export const PaymentType_Dropdown='PaymentType_Dropdown';